module.exports = __webpack_public_path__ + "img/patchouli knowledge_sc2.acba06df.png";